import Configuration from '../model/Configuration';

export default class ConfigurationUtils {

  static isHybridized(config) {
    switch (config) {
      case Configuration.sp:
      case Configuration.spP:
      case Configuration.spPP:
      case Configuration.sp2:
      case Configuration.sp2P:
      case Configuration.sp3:
      case Configuration.sp3d:
      case Configuration.sp3d2:
        return true;
      default:
        return false;
    }
  }

  static isHybridizable(config) {
    switch (config) {
      case Configuration.SP:
      case Configuration.SPP:
      case Configuration.SPPP:
      case Configuration.SPPPD:
      case Configuration.SPPPDD:
        return true;
      default:
        return false;
    }
  }

  static countS(config) {
    switch (config) {
      case Configuration.S:
      case Configuration.SP:
      case Configuration.SPP:
      case Configuration.SPPP:
      case Configuration.SD:
      case Configuration.SPD:
      case Configuration.SPPD:
      case Configuration.SPPPD:
      case Configuration.SDD:
      case Configuration.SPDD:
      case Configuration.SPPDD:
      case Configuration.SPPPDD:
        return 1;
      default:
        return 0;
    }
    return isSConfig ? 1 : 0;
  }

  static countP(config) {
    switch (config) {
      case Configuration.P:
      case Configuration.SP:
      case Configuration.spP:
      case Configuration.sp2P:
      case Configuration.PD:
      case Configuration.PDD:
      case Configuration.SPD:
      case Configuration.SPDD:
        return 1;
      case Configuration.PP:
      case Configuration.PPD:
      case Configuration.PPDD:
      case Configuration.SPP:
      case Configuration.SPPD:
      case Configuration.SPPDD:
      case Configuration.spPP:
        return 2;
      case Configuration.PPP:
      case Configuration.PPPD:
      case Configuration.PPPDD:
      case Configuration.SPPP:
      case Configuration.SPPPD:
      case Configuration.SPPPDD:
        return 3;
      default:
        return 0;
    }
  }

  static countD(config) {
    switch (config) {
      case Configuration.D:
      case Configuration.SD:
      case Configuration.SPD:
      case Configuration.SPPD:
      case Configuration.SPPPD:
      case Configuration.PD:
      case Configuration.PPD:
      case Configuration.PPPD:
        return 1;
      case Configuration.DD:
      case Configuration.SDD:
      case Configuration.SPDD:
      case Configuration.SPPDD:
      case Configuration.SPPPDD:
      case Configuration.PDD:
      case Configuration.PPDD:
      case Configuration.PPPDD:
        return 2;
      default:
        return 0;
    }
  }

  static countho(config) {
    switch (config) {
      case Configuration.sp:
      case Configuration.spP:
      case Configuration.spPP:
        return 2;
      case Configuration.sp2:
      case Configuration.sp2P:
        return 3;
      case Configuration.sp3:
        return 4;
      case Configuration.sp3d:
        return 5;
      case Configuration.sp3d2:
        return 6;
      default:
        return 0;
    }
  }



  static getDescription(config) {
    switch (config) {
      case Configuration.D: return 'a D orbital';
      case Configuration.DD: return 'two D orbitals';
      case Configuration.S: return 'an S orbital';
      case Configuration.SD: return 'an S and a D orbital';
      case Configuration.SDD: return 'an S and two D orbitals';
      case Configuration.SP: return 'an S and a P orbital';
      case Configuration.SPD: return 'an S, a P and a D orbital';
      case Configuration.SPDD: return 'an S, a P and two D orbitals';
      case Configuration.SPP: return 'an S and two P orbitals';
      case Configuration.SPPD: return 'an S, D and two P orbitals';
      case Configuration.SPPDD: return 'an S, two P orbitals and two D orbitals';
      case Configuration.SPPP: return 'an S and three P orbitals';
      case Configuration.SPPPD: return 'an S, D and three P orbitals';
      case Configuration.SPPPDD: return 'an S, two D and and three P orbitals';
      case Configuration.P: return 'a P orbital';
      case Configuration.PD: return 'a P and a D orbital';
      case Configuration.PDD: return 'a P and two D orbitals';
      case Configuration.PP: return 'two P orbitals';
      case Configuration.PPD: return 'two P and a D orbital';
      case Configuration.PPDD: return 'two P and two D orbitals';
      case Configuration.PPP: return 'three P orbitals';
      case Configuration.PPPD: return 'three P and a D orbital';
      case Configuration.PPPDD: return 'three P and two D orbitals';
      case Configuration.sp: return 'two sp orbitals';
      case Configuration.spP: return 'two sp and a P orbital';
      case Configuration.spPP: return 'two sp and two P orbitals';
      case Configuration.sp2: return 'three sp2 orbitals';
      case Configuration.sp2P: return 'three sp2 orbitals and a P orbital';
      case Configuration.sp3: return 'four sp3 orbitals';
      case Configuration.sp3d: return 'five sp3d orbitals';
      case Configuration.sp3d2: return 'six sp3d2 orbitals';
      case Configuration.empty:
      default:
        return '';
    }
  }

  static getDescriptionWithSigma(config) {
    switch (config) {
      case Configuration.sp: return 'an sp orbital';
      case Configuration.spP: return 'an sp and a P orbital';
      case Configuration.spPP: return 'an sp and two P orbitals';
      case Configuration.sp2: return 'two sp2 orbitals';
      case Configuration.sp2P: return 'two sp2 orbitals and a P orbital';
      case Configuration.sp3: return 'three sp3 orbitals';
      case Configuration.sp3d: return 'four sp3d orbitals';
      case Configuration.sp3d2: return 'five sp3d2 orbitals';
      default:
        return '';

    }
  }

  static getDescriptionWithOnePi(config) {
    switch (config) {
      case Configuration.sp: return 'nothing';
      case Configuration.spP: return 'an sp orbital';
      case Configuration.spPP: return 'an sp and one P orbitals';
      case Configuration.sp2: return 'two sp2 orbitals';
      case Configuration.sp2P: return 'two sp2 orbitals';
      case Configuration.sp3: return 'three sp3 orbitals';
      case Configuration.empty:
      default:
        return '';

    }
  }

  static getDescriptionWithTwoPi(config) {
    if (config === Configuration.spPP)
      return 'an sp orbital';

    return '';
  }

  static checkForSigma(config1, config2) {
    const sigmaList = [Configuration.sp, Configuration.spP, Configuration.spPP, Configuration.sp2, Configuration.sp2P, Configuration.sp3, Configuration.sp3d, Configuration.sp3d2];
    if (sigmaList.includes(config1) && sigmaList.includes(config2)) {
      return true;
    }
    return false;
  }

}